import { useParams } from 'react-router-dom';
import { Layout } from 'features/Layouts/Layouts';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import styles from './OperationsPaymentDetails.module.scss';
import { useGetOperationsDetailsPaymentsQuery } from 'redux/Api/operationsApi/operationsApi';
import { DealDetailsItemRight } from 'components/DealDetailsItemRight';

export const OperationsPaymentDetails = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetOperationsDetailsPaymentsQuery({
    name: `payments/${id}`,
  });
  return (
    <Layout>
      {isLoading ? (
        <LoadingSkeleton mt />
      ) : (
        data && (
          <div className={styles.root}>
            <DealDetailsItemRight data={data} />
          </div>
        )
      )}
    </Layout>
  );
};
